import { render, staticRenderFns } from "./TreatmentAdd.vue?vue&type=template&id=d28f9bda&scoped=true&"
import script from "./TreatmentAdd.vue?vue&type=script&lang=js&"
export * from "./TreatmentAdd.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TreatmentAdd.vue?vue&type=style&index=1&id=d28f9bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28f9bda",
  null
  
)

export default component.exports